import { FC, useCallback, useMemo } from "react";
import {
  ReactSelectPlaceholder,
  ReactSelectStyles,
} from "@/consts/ReactSelect";
import {
  SearchConditionGroupResponse,
  SearchConditionValueEntity,
} from "@/web-client";
import Select from "react-select";
import { useRouter } from "next/router";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";

interface SearchConditionGroupPullDownProps {
  searchConditionGroup: SearchConditionGroupResponse;
  selectedIds: number[];
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

export const SearchConditionGroupPullDown: FC<
  SearchConditionGroupPullDownProps
> = ({
  searchConditionGroup: { label, values },
  selectedIds,
  queryController,
}): JSX.Element => {
  // パラメーターから現在選択されている詳細検索項目を取得
  const selectedValue = useMemo<SearchConditionValueEntity | undefined>(() => {
    return values.find(({ id }) => selectedIds.includes(id));
  }, [values, selectedIds]);

  // プルダウンを変更した時のハンドラ
  const router = useRouter();
  const changeSelectHandler = useCallback(
    (to) => {
      // 前選択されていたものを削除
      const filtered = selectedIds.filter((id) => id !== selectedValue?.id);

      // 選択なし（to.value === 0）でなければ、選択された項目のvalueを配列に追加する
      const newSelectedIds = to.value ? [...filtered, to.value] : filtered;

      // URLを更新
      router.push(
        queryController.toPath({
          search_condition_value_ids: newSelectedIds.join(","),
        }),
      );
    },
    [queryController, router, selectedIds, selectedValue],
  );

  // 選択可能な項目
  const options = useMemo(() => {
    return [
      { value: 0, label: "選択なし" },
      ...values.map(({ id, label }) => {
        return {
          value: id,
          label,
        };
      }),
    ];
  }, [values]);

  return (
    <Select
      instanceId={label}
      options={options}
      value={
        selectedValue
          ? { value: selectedValue.id, label: selectedValue.label }
          : null
      }
      onChange={changeSelectHandler}
      styles={ReactSelectStyles}
      placeholder={ReactSelectPlaceholder}
    />
  );
};
